import { render, staticRenderFns } from "./WPCard.vue?vue&type=template&id=a8d17622"
import script from "./WPCard.vue?vue&type=script&lang=ts"
export * from "./WPCard.vue?vue&type=script&lang=ts"
import style0 from "./WPCard.vue?vue&type=style&index=0&id=a8d17622&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports